
import React, { useState, useEffect } from "react";
import {
  Search,
  ChevronLeft,
  ChevronRight,
  CloudDownload,
  X,
  Check,
} from "lucide-react";
import "../Style/Over-AirUpdatesLogs.css";

// Helper function to calculate time difference and format it
const calculateDuration = (start, end) => {
  if (!start || !end) return "N/A";
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (isNaN(startDate) || isNaN(endDate)) return "Invalid Date";

  let diff = Math.abs(endDate - startDate) / 1000; // difference in seconds

  const minutes = Math.floor(diff / 60);
  const seconds = Math.floor(diff % 60);

  let result = "";
  if (minutes > 0) {
    result += `${minutes}m `;
  }
  result += `${seconds}s`;

  return result.trim();
};

// Dummy data for Firmware Logs as requested
const mockFirmwareData = [
  {
    id: "FW001",
    deviceName: "DEV_TSUYOTES01",
    RequestPending: "2025-09-16T10:00:00Z",
    RequestReceived: "2025-09-16T10:00:05Z",
    PackageDownloading: "2025-09-16T10:00:15Z",
    UpdateStaging: "2025-09-16T10:01:45Z",
    WaitingForPreconditions: "2025-09-16T10:01:55Z",
    UpdateinProgress: "2025-09-16T10:02:10Z",
    UpdateComplete: "2025-09-16T10:03:30Z",
    status: "Success",
    AprovalTime: "2025-09-16T10:04:00Z",
    ApprovedBy: "AdminUser",
    createdBy: "System",
    TotalTime: "3m 30s",
  },
  {
    id: "FW002",
    deviceName: "DEV_TSUYOTES03",
    RequestPending: "2025-09-16T11:30:00Z",
    RequestReceived: "2025-09-16T11:30:08Z",
    PackageDownloading: "2025-09-16T11:30:20Z",
    UpdateStaging: "2025-09-16T11:32:00Z",
    WaitingForPreconditions: null,
    UpdateinProgress: "2025-09-16T11:32:15Z",
    UpdateComplete: "2025-09-16T11:34:00Z",
    status: "Failed",
    AprovalTime: "2025-09-16T11:34:30Z",
    ApprovedBy: "AdminUser",
    createdBy: "System",
    TotalTime: "4m 0s",
  },
  {
    id: "FW003",
    deviceName: "DEV_TSUYOTES04",
    RequestPending: "2025-09-16T10:00:00Z",
    RequestReceived: "2025-09-16T10:00:05Z",
    PackageDownloading: "2025-09-16T10:00:15Z",
    UpdateStaging: "2025-09-16T10:01:45Z",
    WaitingForPreconditions: "2025-09-16T10:01:55Z",
    UpdateinProgress: "2025-09-16T10:02:10Z",
    UpdateComplete: "2025-09-16T10:03:30Z",
    status: "Downloading",
    AprovalTime: "2025-09-16T10:04:00Z",
    ApprovedBy: "AdminUser",
    createdBy: "System",
    TotalTime: "3m 30s",
  },
  {
    id: "FW004",
    deviceName: "DEV_TSUYOTES02",
    RequestPending: "2025-09-16T10:00:00Z",
    RequestReceived: "2025-09-16T10:00:05Z",
    PackageDownloading: "2025-09-16T10:00:15Z",
    UpdateStaging: "2025-09-16T10:01:45Z",
    WaitingForPreconditions: "2025-09-16T10:01:55Z",
    UpdateinProgress: "2025-09-16T10:02:10Z",
    UpdateComplete: "2025-09-16T10:03:30Z",
    status: "Failed",
    AprovalTime: "2025-09-16T10:04:00Z",
    ApprovedBy: "AdminUser",
    createdBy: "System",
    TotalTime: "3m 30s",
  },
  {
    id: "FW005",
    deviceName: "DEV_TSUYOTES05",
    RequestPending: "2025-09-16T10:00:00Z",
    RequestReceived: "2025-09-16T10:00:05Z",
    PackageDownloading: "2025-09-16T10:00:15Z",
    UpdateStaging: "2025-09-16T10:01:45Z",
    WaitingForPreconditions: "2025-09-16T10:01:55Z",
    UpdateinProgress: "2025-09-16T10:02:10Z",
    UpdateComplete: "2025-09-16T10:03:30Z",
    status: "Downloading",
    AprovalTime: "2025-09-16T10:04:00Z",
    ApprovedBy: "AdminUser",
    createdBy: "System",
    TotalTime: "3m 30s",
  },
];

// ## Component for Parameter Logs Table ##
const ParameterLogsTable = ({ devices }) => {
  const parameterColumns = [
    "Device Name",
    "Device Id",
    "Vehicle Number",
    "IMEI",
    "SIM Number",
    "VIN Number",
    "Customer ID",
    "Change By",
    "Parameter Update",
    "Last Change",
    "Last Time",
  ];

  return (
    <div className="overflow-x-auto">
      <table className="table-Devices">
        <thead className="table-header-Devices">
          <tr>
            {parameterColumns.map((col) => (
              <th key={col} className="table-cell-Devices">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {devices.length > 0 ? (
            devices.map((device) => (
              <tr key={device.DeviceID}>
                <td className="table-cell-Devices">{device.DeviceName}</td>
                <td className="table-cell-Devices">{device.DeviceID}</td>
                <td className="table-cell-Devices">{device.VehicleID}</td>
                <td className="table-cell-Devices">{device.IMEI}</td>
                <td className="table-cell-Devices">{device.SIM}</td>
                <td className="table-cell-Devices">{device.VIN}</td>
                <td className="table-cell-Devices">{device.CustomerID}</td>
                {/* Dummy data for the last two columns */}
                <td className="table-cell-Devices">AdminUsed</td>
                <td className="table-cell-Devices">Harsh Acceleration</td>
                <td className="table-cell-Devices">Config Change</td>
                <td className="table-cell-Devices">
                  {new Date().toLocaleString()}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={parameterColumns.length}
                className="empty-message-Devices"
              >
                No Devices Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

// ## Component for Firmware Logs Table ##
const FirmwareLogsTable = () => {
  const firmwareDurationColumns = [
    "DeviceName",
    "PendingReceived",
    "ReceivedDownloading",
    "DownloadingStaging",
    "StagingPreconditions",
    "PreconditionsInProgress",
    "InProgressComplete",
    "RolloutCreativeTime",
    "Status",
    "AprovalTime",
    "ApprovedBy",
    "createdBy",
    "TotalTime",
  ];

  return (
    <div className="overflow-x-auto">
      <table className="table-Devices">
        <thead className="table-header-Devices">
          <tr>
            {firmwareDurationColumns.map((col) => (
              <th key={col} className="table-cell-Devices">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {mockFirmwareData.map((log) => (
            <tr key={log.id}>
              <td className="table-cell-Devices">{log.deviceName}</td>
              <td className="table-cell-Devices">
                {calculateDuration(log.RequestPending, log.RequestReceived)}
              </td>
              <td className="table-cell-Devices">
                {calculateDuration(log.RequestReceived, log.PackageDownloading)}
              </td>
              <td className="table-cell-Devices">
                {calculateDuration(log.PackageDownloading, log.UpdateStaging)}
              </td>
              <td className="table-cell-Devices">
                {calculateDuration(
                  log.UpdateStaging,
                  log.WaitingForPreconditions,
                )}
              </td>
              <td className="table-cell-Devices">
                {calculateDuration(
                  log.WaitingForPreconditions,
                  log.UpdateinProgress,
                )}
              </td>
              <td className="table-cell-Devices">
                {calculateDuration(log.UpdateinProgress, log.UpdateComplete)}
              </td>
              <td className="table-cell-Devices ">
                {calculateDuration(log.RequestPending, log.UpdateComplete)}
              </td>
              <td className="table-cell-Devices font-bold-Devices">
                {log.status}
              </td>
              <td className="table-cell-Devices">
                {log.AprovalTime
                  ? new Date(log.AprovalTime).toLocaleString()
                  : "N/A"}
              </td>
              <td className="table-cell-Devices">{log.ApprovedBy || "N/A"}</td>
              <td className="table-cell-Devices">{log.createdBy || "N/A"}</td>
              <td className="table-cell-Devices">
                {log.TotalTime ||
                  calculateDuration(log.RequestPending, log.UpdateComplete)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default function Devices() {
  const deviceColumns = [
    "Device Name",
    "Device Id",
    "Vehicle Number",
    "IMEI",
    "SIM Number",
    "VIN Number ",
    "Customer ID",
    "Download Logs",
  ];

  const [devices, setDevices] = useState([]);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  // State to manage which log view is active
  const [activeLogType, setActiveLogType] = useState("Device"); // 'Device', 'Parameter', 'Firmware'

  useEffect(() => {
    fetchDevices();
  }, []);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredDevices(devices);
    } else {
      const filtered = devices.filter((device) =>
        device.DeviceName.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredDevices(filtered);
    }
  }, [searchTerm, devices]);

  const showNotification = (message, type = "info") => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: "", type: "" });
    }, 5000);
  };

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Authentication token not found. Please log in again.");
        setLoading(false);
        return;
      }

      const response = await fetch(
        "https://api.yellowmatrix.co.in/devicereg/assigned",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // CORRECTED: Checks for data.Devices (plural)
      if (data.Devices && Array.isArray(data.Devices)) {
        const formattedDevices = data.Devices.map((device) => ({
          DeviceName: device.Vehicle.VehicleID,
          DeviceID: device.DeviceID,
          VehicleID: device.Vehicle.VehicleID,
          IMEI: device.IMEI,
          ICCID: device.ICCID,
          VIN: device.Vehicle.VIM,
          CustomerID: device.Customerid,
        }));

        setDevices(formattedDevices);
        setFilteredDevices(formattedDevices);
      } else {
        throw new Error("Invalid response format: Device array not found");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadLogs = async (deviceId, customerId, deviceName) => {
    setDownloading(deviceId);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Authentication token not found. Please log in again.");
        setDownloading(null);
        return;
      }
      const response = await fetch("https://api.yellowmatrix.co.in/getlogs", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerid: customerId,
          deviceid: deviceId,
        }),
      });
      if (!response.ok) {
        if (response.status === 404) {
          const errorData = await response.json();
          throw new Error(errorData.Error || "No logs found for this device");
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const contentType = response.headers.get("content-type");
      if (
        contentType &&
        contentType.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        )
      ) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        const safeDeviceName = deviceName.replace(/[^a-zA-Z0-9]/g, "_");
        a.download = `logs_${safeDeviceName}_${timestamp}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        showNotification(
          `Logs downloaded successfully for ${deviceName}`,
          "success",
        );
      } else {
        throw new Error("Unexpected response format from server");
      }
    } catch (err) {
      showNotification(`Failed to download logs: ${err.message}`, "error");
    } finally {
      setDownloading(null);
    }
  };

  const handleDownloadSelectedLogs = () => {
    if (selectedDevice) {
      handleDownloadLogs(
        selectedDevice.DeviceID,
        selectedDevice.CustomerID,
        selectedDevice.DeviceName,
      );
    } else {
      showNotification("Please select a device first", "error");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const closeNotification = () => {
    setNotification({ show: false, message: "", type: "" });
  };

  const openDeviceModal = () => setShowDeviceModal(true);
  const closeModal = () => setShowDeviceModal(false);

  const handleDeviceSelect = (device) => {
    setSelectedDevice(device);
    setShowDeviceModal(false);
    showNotification(
      `Device "${device.DeviceName}" selected successfully`,
      "success",
    );
  };

  const clearSelection = () => {
    setSelectedDevice(null);
    showNotification("Device selection cleared", "info");
  };

  // Function to render the correct table based on activeLogType
  const renderLogTable = () => {
    switch (activeLogType) {
      case "Parameter":
        return <ParameterLogsTable devices={filteredDevices} />;
      case "Firmware":
        return <FirmwareLogsTable />;
      case "Device":
      default:
        return (
          <div className="overflow-x-auto">
            <table className="table-Devices">
              <thead className="table-header-Devices">
                <tr>
                  {deviceColumns.map((col) => (
                    <th key={col} className="table-cell-Devices">
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredDevices.length > 0 ? (
                  filteredDevices.map((device) => (
                    <tr key={device.DeviceID}>
                      <td className="table-cell-Devices">
                        {device.DeviceName || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.DeviceID || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.VehicleID || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.IMEI || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.ICCID || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.VIN || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        {device.CustomerID || "N/A"}
                      </td>
                      <td className="table-cell-Devices">
                        <button
                          onClick={() =>
                            handleDownloadLogs(
                              device.DeviceID,
                              device.CustomerID,
                              device.DeviceName,
                            )
                          }
                          className={`download-button-Devices ${
                            downloading === device.DeviceID
                              ? "downloading-Devices"
                              : ""
                          }`}
                          disabled={downloading === device.DeviceID}
                          aria-label={`Download logs for ${device.DeviceName}`}
                        >
                          {downloading === device.DeviceID ? (
                            "Downloading..."
                          ) : (
                            <CloudDownload size={20} />
                          )}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={deviceColumns.length}
                      className="empty-message-Devices"
                    >
                      {searchTerm
                        ? "No devices match your search"
                        : "No Devices Found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
    }
  };

  return (
    <div className="container-Devices">
      {notification.show && (
        <div
          className={`notification-overlay notification-${notification.type}`}
        >
          <div className="notification-content">
            <span>{notification.message}</span>
            <button onClick={closeNotification} className="notification-close">
              <X size={18} />
            </button>
          </div>
        </div>
      )}

      {showDeviceModal && (
        <div className="modal-overlay-Devices">
          <div className="modal-container-Devices">
            <div className="modal-header-Devices">
              <h2>Choose Device</h2>
              <button onClick={closeModal} className="modal-close-Devices">
                <X size={24} />
              </button>
            </div>
            <div className="modal-content-Devices">
              <div className="device-list-Devices">
                {devices.map((device) => (
                  <div
                    key={device.DeviceID}
                    className={`device-item-Devices ${
                      selectedDevice?.DeviceID === device.DeviceID
                        ? "selected-Devices"
                        : ""
                    }`}
                    onClick={() => handleDeviceSelect(device)}
                  >
                    <div className="device-info-Devices">
                      <div className="device-name-Devices">
                        {device.DeviceName}
                      </div>
                      <div className="device-details-Devices">
                        <span>Device ID: {device.DeviceID}</span>
                        <span>Customer ID: {device.CustomerID}</span>
                      </div>
                    </div>
                    {selectedDevice?.DeviceID === device.DeviceID && (
                      <div className="device-selected-indicator">
                        <Check size={16} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer-Devices">
              <button
                onClick={closeModal}
                className="modal-button-Devices cancel-Devices"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <header className="header-Devices">
        <h1 className="header-title-Devices">Devices</h1>
        <p className="header-subtitle-Devices">
          Track, manage, and analyze your devices seamlessly.
        </p>
      </header>
      <hr className="line-Devices" width="100%" />

      {selectedDevice && (
        <div className="selected-device-banner">
          <div className="selected-device-content">
            <span>
              Selected Device: <strong>{selectedDevice.DeviceName}</strong> (ID:{" "}
              {selectedDevice.DeviceID})
            </span>
            <button
              onClick={clearSelection}
              className="clear-selection-btn-Devices"
            >
              Change Device
            </button>
          </div>
        </div>
      )}

      <div className="button-group-Devices">
        <button
          className={`button-Logs-Devices ${
            activeLogType === "Device" ? "active" : ""
          }`}
          onClick={() => setActiveLogType("Device")}
        >
          Devices Logs
        </button>
        <button
          className={`button-Logs-Devices ${
            activeLogType === "Parameter" ? "active" : ""
          }`}
          onClick={() => setActiveLogType("Parameter")}
        >
          Parameter Logs
        </button>
        <button
          className={`button-Logs-Devices ${
            activeLogType === "Firmware" ? "active" : ""
          }`}
          onClick={() => setActiveLogType("Firmware")}
        >
          Firmware Logs
        </button>
        <button className="button-text-Devices" onClick={openDeviceModal}>
          CHOOSE DEVICE
        </button>
        <button
          className="button-text-Devices"
          onClick={handleDownloadSelectedLogs}
          disabled={!selectedDevice || downloading}
        >
          {downloading ? "DOWNLOADING..." : "DOWNLOAD LOGS"}
        </button>
      </div>

      <div className="table-wrapper-Devices">
        <div className="p-4">
          <div className="search-container-Devices">
            <Search className="search-icon-Devices" size={20} />
            <input
              type="text"
              className="search-input-Devices"
              placeholder="Search devices by name..."
              value={searchTerm}
              onChange={handleSearchChange}
              disabled={activeLogType === "Firmware"} // Disable search for Firmware logs
            />
          </div>
        </div>

        {loading ? (
          <div className="loading-Devices">Loading devices...</div>
        ) : error ? (
          <div className="error-Devices">
            Error: {error}
            <button onClick={fetchDevices} className="retry-button-Devices">
              Retry
            </button>
          </div>
        ) : (
          <>
            {renderLogTable()}
            <div className="pagination-Devices">
              {/* Pagination can be further customized based on active log type */}
              <div className="flex items-center mb-4 sm:mb-0">
                <span>Rows per page:</span>
                <select className="rows-selector-Devices">
                  <option>5</option>
                  <option>10</option>
                  <option>20</option>
                </select>
              </div>
              <div className="pagination-controls-Devices">
                <span>
                  1-{filteredDevices.length} of {filteredDevices.length}
                </span>
                <div className="pagination-buttons-Devices">
                  <button className="pagination-button-Devices" disabled>
                    <ChevronLeft size={20} />
                  </button>
                  <button className="pagination-button-Devices" disabled>
                    <ChevronRight size={20} />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
